"use client";

import Image from "next/image";
import Flex from "@/shared/components/common/Flex";
import { CancelRulesCard } from "./Components/CancelRulesCard";
import { CancelRulesMobileCard } from "./Components/CancelRulesMobileCard";
import InfoCard from "@/containers/components/cards/infoCard/InfoCard";
import { useDeviceType } from "@/shared/context/DeviceContext";

interface RefundRulesBodyProps {
  data: RefundRule[];
}

export const CancelRulesBody = ({
  data: refundRules,
}: RefundRulesBodyProps) => {
  const deviceType = useDeviceType();

  return (
    <Flex className="w-full flex-col gap-8 rounded-xs justify-center ">
      {refundRules.map((rule) => (
        <InfoCard
          header={{
            title: rule.airline,
            icon: (
              <Image
                src={rule.logo}
                width={40}
                height={40}
                alt={rule.airline}
              />
            ),
          }}
          key={rule.airline}
          defaultStyle={3}
        >
          {deviceType === "mobile" ? (
            <CancelRulesMobileCard rule={rule} />
          ) : (
            <CancelRulesCard rule={rule} />
          )}
        </InfoCard>
      ))}
    </Flex>
  );
};
